// Configuration file for the Guest Stream request

// Environment detection - check both env vars and current domain
const isProd = process.env.REACT_APP_ENV === 'production' || 
               process.env.NODE_ENV === 'production' ||
               (typeof window !== 'undefined' && window.location.hostname === 'guest-stream-frontend.fly.dev');

// Environment-specific URLs
const ENVIRONMENTS = {
  local: {
    api: 'http://localhost:8000',
    ai: 'http://localhost:8015',
  },
  production: {
    api: 'https://guest-stream-api.fly.dev',
    ai: '',
  },
};

// Smart URL selection: explicit env vars take absolute priority, then environment-based defaults
export const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_URL || (isProd ? ENVIRONMENTS.production.api : ENVIRONMENTS.local.api),
  environment: isProd ? 'production' : 'local',
};

// AI Service Configuration
const aiBaseUrl = process.env.REACT_APP_AI_URL || (isProd ? ENVIRONMENTS.production.ai : ENVIRONMENTS.local.ai);
const legacyAiEnabled = process.env.REACT_APP_AI_ENABLED === 'true' && aiBaseUrl.length > 0;

export const AI_CONFIG = {
  enabled: legacyAiEnabled,
  baseUrl: aiBaseUrl,
  environment: isProd ? 'production' : 'local',
  features: {
    accountVerification: legacyAiEnabled,
    guestScoring: legacyAiEnabled && process.env.REACT_APP_AI_SCORING_ENABLED === 'true',
    riskScreening: legacyAiEnabled,
    collaborationSuggestions: false, // TODO: Re-enable AI-suggested collaborators feature once ready
    batchAnalysis: legacyAiEnabled,
  },
  // Thresholds for AI features
  thresholds: {
    verificationConfidence: 0.7, // Minimum confidence for verification
    guestScoreGood: 80,      // Score above this is considered good
    guestScoreAcceptable: 60, // Score above this is acceptable
    riskLevelAcceptable: 'medium', // Maximum acceptable risk level
    lowRisk: 0.3, // Risk score below this is considered low
  },
};

// Feature flags
export const FEATURES = {
  aiIntegration: AI_CONFIG.enabled,
  collabStats: process.env.REACT_APP_COLLAB_STATS_ENABLED === 'true' || false, // Experimental: YouTube collab performance tracking
};

// API server URL - update this to match your FastAPI server location
export const API_URL = API_CONFIG.baseUrl;

// Other global configuration settings can go here
export const APP_NAME = "Guest Shoot Platform";
